const config = {
  mapbox_gl_token: 'pk.eyJ1IjoiZGNhaXJucyIsImEiOiJjanM4YmZmb3kxYTVxM3l0ZnJiNmJ4cXkwIn0.O6iCF0hbunCynqLJGMftuQ',
  watersheds: ['Sturgeon', 'Vermilion'],
  adminUsers: ['dcairns', 'nswa_me']
};

export default config
